import { useLanguage } from '@/i18n/LanguageContext';
import { Instagram, Facebook, Mail, MapPin, Send } from 'lucide-react';
import { Link } from 'react-router-dom';
import logoImg from '@/assets/logo-roma-dream-escape.png';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-border/30 bg-secondary/20 py-16">
      <div className="container mx-auto px-6">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <img src={logoImg} alt="Roma Dream Escape" className="h-28 w-auto" width="196" height="112" />
            <p className="mt-3 font-sans text-sm text-muted-foreground">
              Premium holiday apartments in Rome's most iconic neighborhoods.
            </p>
            <div className="mt-4 flex gap-4">
              <a href="https://www.instagram.com/roma_dream_escape" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-muted-foreground transition-colors hover:text-primary">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61588517561368" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-muted-foreground transition-colors hover:text-primary">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" aria-label="Pinterest" className="text-muted-foreground transition-colors hover:text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5"><path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 4"/><line x1="12" y1="12" x2="12" y2="22"/></svg>
              </a>
              <a href="#" aria-label="Telegram" className="text-muted-foreground transition-colors hover:text-primary">
                <Send className="h-5 w-5" />
              </a>
              <a href="mailto:info@romadreamescape.com" aria-label="Email us" className="text-muted-foreground transition-colors hover:text-primary">
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <p className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Quick Links</p>
            <div className="mt-4 flex flex-col gap-2">
              <a href="#apartments" className="text-sm text-foreground/70 transition-colors hover:text-primary">{t.nav.apartments}</a>
              <a href="#experiences" className="text-sm text-foreground/70 transition-colors hover:text-primary">{t.nav.experiences}</a>
              <a href="#about" className="text-sm text-foreground/70 transition-colors hover:text-primary">{t.nav.about}</a>
              <a href="#contact" className="text-sm text-foreground/70 transition-colors hover:text-primary">{t.nav.contact}</a>
            </div>
          </div>

          <div>
            <p className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Contact</p>
            <div className="mt-4 flex items-start gap-2 text-sm text-foreground/70">
              <MapPin className="mt-0.5 h-4 w-4 text-primary/60" />
              <span>Rome, Italy</span>
            </div>
            <a href="mailto:info@romadreamescape.com" className="mt-2 block text-sm text-foreground/70 transition-colors hover:text-primary">
              info@romadreamescape.com
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-border/20 pt-8 text-center">
          <div className="mb-3 flex justify-center gap-4">
            <Link to="/privacy" className="text-xs text-muted-foreground transition-colors hover:text-primary">{t.footer.privacy}</Link>
            <Link to="/terms" className="text-xs text-muted-foreground transition-colors hover:text-primary">{t.footer.terms}</Link>
          </div>
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Roma Dream Escape. {t.footer.rights}.
          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;